// Recovered compiled webpack factory 98387. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { D: () => a });
  var n = i(55389),
    s = i(81288),
    r = i(83370);
  let o = {
      ...i(96868).W,
      color: n.y,
      backgroundColor: n.y,
      outlineColor: n.y,
      fill: n.y,
      stroke: n.y,
      borderColor: n.y,
      borderTopColor: n.y,
      borderRightColor: n.y,
      borderBottomColor: n.y,
      borderLeftColor: n.y,
      filter: s.p,
      WebkitFilter: s.p,
      mask: r.d,
      WebkitMask: r.d,
    },
    a = (t) => o[t];
}
